module.exports = __webpack_public_path__ + "img/Navipoint-Dual-kit.5655926c.png";